// @flow

export const USER_EMAIL_SAVE_PHONE_SUCCESS = 'USER_EMAIL_SAVE_PHONE_SUCCESS'
